import script from "./HospitalScreenPatientList.vue?vue&type=script&setup=true&lang=js"
export * from "./HospitalScreenPatientList.vue?vue&type=script&setup=true&lang=js"

import "./HospitalScreenPatientList.vue?vue&type=style&index=0&id=08fbf078&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fbf078"]])

export default __exports__